import React from 'react';
import { Input } from '@apia/theme';
import useContext from '../../../../hooks/useContext';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import FieldContext from '../fieldsStore/FieldContext';
import MakeField from '../fieldsStore/MakeField';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';

const ApiaHiddenInput = MakeField(
  React.forwardRef<HTMLInputElement>(() => {
    const {
      state: { value },
    } = useContext(FieldContext);
    const { field } = useContext(ApiaComponentContextPrimitive);
    const { attName, properties } = field;
    const { name } = properties;

    const { identifier } = useApiaFieldCommonProps();

    return (
      <Input
        name={name || attName}
        type="hidden"
        value={value as string}
        {...identifier}
      />
    );
  }),
  {
    preSynchronize() {
      return true;
    },
  },
);

export default ApiaHiddenInput;
